export const users = {
  unknown: 'inconnu',
  actions: {
    acceptSignup: {
      btnLabel: 'Accepter',
      title: 'Accepter la demande d\'inscription de "{username}"',
    },
    rejectSignup: {
      btnLabel: 'Rejeter',
      title: 'Rejeter la demande d\'inscription de "{username}"',
    },
    resendValidationLink: {
      btnLabel: 'Renvoyer',
      title: 'Renvoyer le lien de validation d\'inscription à "{username}"',
    },
    delete: {
      btnLabel: 'Supprimer',
      title: 'Supprimer l\'utilisateur "{username}"',
    },
    disable: {
      btnLabel: 'Désactiver',
      title: 'Désactiver l\'utilisateur "{username}"',
    },
    updateInfos: {
      btnLabel: 'Modifier',
      title: 'Modifier les informations de l\'utilisateur "{username}"',
    },
    generatePassword: {
      btnLabel: 'Nouveau mot de passe',
      title: 'Générer un nouveau mot de passe pour l\'utilisateur "{username}"',
    },
    updateRoles: {
      btnLabel: 'Rôles',
      title: 'Modifier les rôles de l\'utilisateur "{username}"',
    },
  },
  roles: {
    ROLE_SUPER_ADMIN: 'Gérer les utilisateurs et les administrateurs',
    ROLE_ADMIN:
      'Gérer les utilisateurs (activer / désactiver, modification des rôles, modification du mot de passe et modification du username)',
    ROLE_DEV:
      'Accéder à des informations de journalisation pour débuguer plus facilement',
    ROLE_VIDEO_VALIDATE: 'Valider les vidéos déposés par les utilisateurs',
    ROLE_USER_VALIDATE: 'Valider les utilisateurs qui se sont inscrit',
    ROLE_PRG_EDIT: "Modifier le commentaire d'un programme",
    ROLE_VIDEO_ADD: 'Ajouter une vidéo et ainsi la soumettre au valideur',
    ROLE_READ: 'Accès au visionnage des vidéos validées',
  },
  rolesShort: {
    ROLE_SUPER_ADMIN: 'Super admin',
    ROLE_ADMIN: 'Admin',
    ROLE_DEV: 'Développeur',
    ROLE_VIDEO_VALIDATE: 'Valideur de vidéo',
    ROLE_USER_VALIDATE: "Valideur d'utilisateur",
    ROLE_PRG_EDIT: 'Editeur de programme',
    ROLE_VIDEO_ADD: 'Dépôt de vidéo',
    ROLE_READ: 'Lecture des vidéos',    
  },
};
